let body = $('body');
let menu = $('.main-menu');
let button = $('.products-item');
let mega_menu = $('.mega-menu');
let mega_row = $('.megamenu-row');
let mega_column = $('.megamenu-column');
let mega_element = $('.sub_categories__element');
let trigger = $('.menu-trigger');

let languageButton = $('.ico-language--active');
let languageMenu = languageButton.parent();

let query = Modernizr.mq('(min-width: 1025px)');

export function init()
{
    $(document).click(function(e) {
         if (query) {
            if ($(e.target).attr('class') != button.attr('class')
                && $(e.target).attr('class') != mega_menu.attr('class')
                && $(e.target).attr('class') != mega_row.attr('class')
                && $(e.target).attr('class') != mega_column.attr('class')
                &&  $(e.target).attr('class') != mega_element.attr('class')
                && mega_menu.hasClass('is-open')
            ) {
                close_Megamenu();
            }
        }

        if ($(e.target).attr('class') != languageMenu.attr('class')
            && $(e.target).attr('class') != languageButton.attr('class')
            && $(e.target).parent().attr('class') != languageButton.attr('class')
            && languageMenu.hasClass('open')
        ) {
            close_Languagemenu();
        }
    });

    if (query) {
       button.on('click', OpenClose_Mega);
    }

    trigger.on('click', Menu_Trigger);

    languageButton.on('click', languageTrigger);
}

function OpenClose_Mega()
{
    if (mega_menu.hasClass('is-open')) {
        mega_menu.removeClass('is-open');
        button.removeClass('active');
    } else {
        mega_menu.addClass('is-open');
        button.addClass('active');
    }
}

function close_Megamenu()
{
    mega_menu.removeClass('is-open');
    button.removeClass('active');
}

function close_Languagemenu()
{
    languageMenu.removeClass('open');
}

function Menu_Trigger()
{
    if (menu.hasClass('is-open')) {
        menu.removeClass('is-open');
        mega_menu.removeClass('is-open');
        body.removeClass('is-open');
    } else {
        menu.addClass('is-open');
        mega_menu.addClass('is-open');
        body.addClass('is-open');
    }
}

function languageTrigger(event)
{
    event.preventDefault();

    if (languageMenu.hasClass('open')) {
        languageMenu.removeClass('open');
    } else {
        languageMenu.addClass('open');
    }
}



// WEBPACK FOOTER //
// ./src/js/modules/menu.js